import script from "./SnapshotView.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapshotView.vue?vue&type=script&setup=true&lang=js"

import "./SnapshotView.vue?vue&type=style&index=0&id=c832aa46&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c832aa46"]])

export default __exports__